<template>
  <div class="item-frame">
    <input
      id="setting-item-1"
      :model="wheelchairToggle"
      type="checkbox"
      class="checkbox"
      @click="wheelchairToggle = !wheelchairToggle"
    />
    <label class="switch" for="setting-item-1"></label>
    <label class="text" style="font-weight: bold" for="setting-item-1"
      >車椅子でのご利用あり</label
    >
  </div>
</template>

<script>
import { useVModel } from "vue-composable";
import { ref } from "vue";

export default {
  name: "WheelchairToggle",
  props: {
    wheelchairToggle: {
      type: Boolean,
      require: true,
    },
  },
  setup(props) {
    const wheelchairToggle = useVModel(props, "wheelchairToggle");

    return {
      wheelchairToggle,
    };
  },
};
</script>

<style scoped lang="scss">
.item-frame {
  text-align: center;
  margin-bottom: 10px;
}
.switch {
  position: relative;
  &:before,
  &:after {
    content: "";
    vertical-align: middle;
    display: inline-block;
  }
  &:before {
    width: 2em;
    height: 1em;
    border: 2px solid #e0e0e0;
    border-radius: 32px;
    background: #999;
  }
  &:after {
    position: relative;
    width: 1em;
    height: 1em;
    background: #e0e0e0;
    border-radius: 50%;
    left: -2.2em;
  }
}
input {
  display: none;
  &:checked {
    ~ .switch {
      &:before {
        background: #7dc270;
        border-color: #7dc270;
      }
      &:after {
        left: -1.1em;
      }
    }
  }
}
</style>
